import About from "./Routes/About";
import Contact from "./Routes/Contact";
import Home from "./Routes/Home";
import Projects from "./Routes/Projects";
import {Route,Routes} from "react-router-dom";

function App() {
  return (
    <>
      <Routes>
        <Route path = "/" element = {<Home />} />
        <Route path = "/Projects" element = {<Projects />} />
        <Route path = "/About" element = {<About />} />
        <Route path = "/Contact" element = {<Contact />} />
      </Routes>
    </> 
  );
}

export default App;
